import { useState, useEffect } from 'react';
import { Grid, Typography, Divider, Button } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';

import AnnotateAssetActionImpl from './AnnotateAssetActionImpl';

export default function AnnotateAssetActionModalContainer() {
  const dispatch = useDispatch();
  
  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="stretch"
      sx={{ width: '100%', height: '100%', minHeight: 0 }}
    >

      <Grid item sx={{ width: '100%', height: '100%', minHeight: 0 }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{ width: '100%', height: '100%', minHeight: 0 }}
          spacing="5"
        >
          <Grid item lg={12} sx={{ width: '100%', height: '100%', minHeight: 0 }}>
            <AnnotateAssetActionImpl />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
